import { useEffect, useState } from "react";

import { cn } from "@/lib/utils";

// The Servecor mark, with the human chain turning inside a still hexagon.
// The placement below comes from backend/scripts/split_brand_mark.py — re-run it and use the
// fractions it prints if the artwork is ever replaced.
const HEX = "/brand/servecor-hex-sm.png";
const RING = "/brand/servecor-ring-sm.png";
const RING_CENTRE_X = 49.79; // % of the mark's width
const RING_CENTRE_Y = 50.43; // % of the mark's height
const RING_WIDTH = 1.1522; // multiples of the mark's width
const HEX_ASPECT = 1.18; // height / width

let ready = false;
const preload = Promise.all([HEX, RING].map((src) => new Promise((done) => {
  const img = new window.Image();
  img.onload = img.onerror = done;
  img.src = src;
}))).then(() => { ready = true; });

export const BrandSpinner = ({ size = 120, className, speed = "2.6s" }) => {
  const [loaded, setLoaded] = useState(ready);
  const [painted, setPainted] = useState(0);
  useEffect(() => {
    if (!ready) preload.then(() => setLoaded(true));
  }, []);

  const ring = size * RING_WIDTH;
  const show = loaded && painted >= 2;
  return (
    <span
      className={cn("relative inline-block shrink-0 transition-opacity duration-200", className)}
      style={{ width: size, height: Math.round(size * HEX_ASPECT), opacity: show ? 1 : 0 }}
      data-testid="brand-spinner"
      aria-hidden="true"
    >
      <img src={HEX} alt="" decoding="sync" onLoad={() => setPainted((n) => n + 1)}
           className="absolute inset-0 h-full w-full max-w-none object-contain" />
      <img src={RING} alt="" decoding="sync" onLoad={() => setPainted((n) => n + 1)}
           className="absolute max-w-none animate-spin"
           style={{
             width: ring, height: ring,
             left: `${RING_CENTRE_X}%`, top: `${RING_CENTRE_Y}%`,
             marginLeft: -ring / 2, marginTop: -ring / 2,
             animationDuration: speed,
           }} />
    </span>
  );
};

export default BrandSpinner;
